module.exports = __webpack_public_path__ + "img/kinderzeitung.e4d6780d.svg";